const selectPageName = (state) => state.utf.pageName;

export { selectPageName };
